import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewSecurityFinishedModel } from '../../models';

import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { AllocationViewActionBaseState } from '../base';
import {
  AllocationViewFinishArrivalSecurityAction,
  AllocationViewFinishArrivalSecurityActionPrepare,
  AllocationViewFinishArrivalSecurityActionSetInitialState,
} from './allocation-view-finish-arrival-security-action.actions';
import { AllocationViewFinishArrivalSecurityActionService } from './allocation-view-finish-arrival-security-action.service';

export interface AllocationViewFinishArrivalSecurityActionStateModel {
  loaded: boolean;
  arrivalSecurityFinishPrepareData: AllocationViewSecurityFinishedModel;
}

const initialState: AllocationViewFinishArrivalSecurityActionStateModel = {
  loaded: false,
  arrivalSecurityFinishPrepareData: null,
};

@State({
  name: 'allocationViewActionsFinishArrivalSecurity',
  defaults: initialState,
})
@Injectable()
export class AllocationViewFinishArrivalSecurityActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewFinishArrivalSecurityActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getArrivalSecurityFinishPrepareData(
    state: AllocationViewFinishArrivalSecurityActionStateModel,
  ): AllocationViewSecurityFinishedModel {
    return state.arrivalSecurityFinishPrepareData;
  }

  constructor(
    private allocationViewFinishArrivalSecurityActionService: AllocationViewFinishArrivalSecurityActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewFinishArrivalSecurityActionPrepare)
  arrivalSecurityFinishPrepare(
    ctx: StateContext<AllocationViewFinishArrivalSecurityActionStateModel>,
    { identifier, language }: AllocationViewFinishArrivalSecurityActionPrepare,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | AllocationViewSecurityFinishedModel> {
    return this.allocationViewFinishArrivalSecurityActionService
      .arrivalSecurityFinishPrepare(identifier, language)
      .pipe(
        tap((response: AllocationViewSecurityFinishedModel) => {
          ctx.patchState({
            arrivalSecurityFinishPrepareData: response,
            loaded: true,
          });
        }),
        catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
      );
  }

  @Action(AllocationViewFinishArrivalSecurityAction)
  arrivalSecurityFinish(
    ctx: StateContext<AllocationViewFinishArrivalSecurityActionStateModel>,
    { data }: AllocationViewFinishArrivalSecurityAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewFinishArrivalSecurityActionService.arrivalSecurityFinish(data).pipe(
      tap(() => {
        this.finishAction('api.uli.success.arrivalSecurityCheckFinished');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewFinishArrivalSecurityActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewFinishArrivalSecurityActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
